module.exports = __webpack_public_path__ + "assets/img/slogan-e16347c4.png";